import { defineStore } from 'pinia'

export interface IncomingNotification {
  userId:    number
  type:      string
  title:     string
  content:   string
  createdAt: string
}

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    unreadCount: 0,
    latest:      null as IncomingNotification | null,
    /**
     * 새 알림이 도착한 직후 true.
     * AdminHeader 의 벨 흔들기 애니메이션 트리거용.
     * 애니메이션 종료 or 벨 클릭 시 clearNew() 로 false 로 되돌린다.
     */
    hasNew: false,
    /**
     * useWebSocket 의 isConnected 상태를 admin.vue 에서 동기화한다.
     * 레이아웃 하위 페이지에서 WS 연결 여부를 조회할 때 사용한다.
     */
    wsConnected: false,
    /**
     * true 로 설정하면 AdminHeader 의 MyNotificationModal 이 열린다.
     * 토스트 클릭 등 헤더 외부에서 모달을 열어야 할 때 사용한다.
     * 모달이 열리는 순간 헤더에서 false 로 리셋된다.
     */
    shouldOpenModal: false,
  }),

  actions: {
    setUnreadCount(count: number) {
      this.unreadCount = count
    },
    incrementUnread() {
      this.unreadCount++
      this.hasNew = true
    },
    decrementUnread() {
      if (this.unreadCount > 0) this.unreadCount--
    },
    setLatest(notification: IncomingNotification) {
      this.latest = notification
    },
    clearNew() {
      this.hasNew = false
    },
    setWsConnected(connected: boolean) {
      this.wsConnected = connected
    },
    requestOpenModal() {
      this.shouldOpenModal = true
    },
    clearOpenModal() {
      this.shouldOpenModal = false
    },
    reset() {
      this.unreadCount = 0
      this.latest = null
      this.hasNew = false
      this.wsConnected = false
      this.shouldOpenModal = false
    },
  },
})
